// src/components/AboutUs.jsx
// Strona „O nas” - sygnały wiarygodności (E-E-A-T): kto prowadzi serwis,
// jak powstają treści, jak je aktualizujemy i gdzie weryfikować przepisy.
import React from 'react';
import { Link } from 'react-router-dom';
import styles from '../css/modules/Page.module.css';
import JsonLd from '../seo/JsonLd';
import { breadcrumbJsonLd, CONTACT_EMAIL } from '../seo/siteMeta';

const AboutUs = () => (
  <>
    <JsonLd
      data={breadcrumbJsonLd([
        { name: 'Strona główna', path: '/' },
        { name: 'O nas', path: '/o-nas' },
      ])}
    />

    <main className={styles.page}>
      <article className={styles.wrap}>
        <nav className={styles.breadcrumbs} aria-label="Ścieżka nawigacji">
          <Link to="/">Strona główna</Link> › <span>O nas</span>
        </nav>

        <h1 className={styles.h1}>O serwisie Zeglarka.pl</h1>

        <p className={styles.lead}>
          Zeglarka.pl to polski serwis z testami online przygotowującymi do egzaminów
          teoretycznych na <strong>patenty żeglarskie i motorowodne</strong>: żeglarza
          jachtowego, sternika motorowodnego i jachtowego sternika morskiego.
        </p>

        <section className={styles.section}>
          <h2>Po co powstał serwis</h2>
          <p>
            Część teoretyczna egzaminu to 75 pytań w 90 minut i próg 65 poprawnych odpowiedzi.
            Materiał rozrzucony jest po przepisach, podręcznikach i notatkach z kursu, a same
            pytania krążą w sieci w kilkunastu wersjach, często bez klucza odpowiedzi.
            Zebraliśmy je w jednym miejscu i przy każdym napisaliśmy, dlaczego dana odpowiedź
            jest poprawna.
          </p>
          <p>
            Symulator odwzorowuje prawdziwy arkusz: losowanie w tych samych proporcjach działów,
            zegar i próg zaliczenia. Wynik dostajesz w rozbiciu na siedem działów, więc od razu
            wiesz, czy siadać do locji, czy do przepisów prawa drogi.
          </p>
        </section>

        <section className={styles.section}>
          <h2>Jak przygotowujemy materiały</h2>
          <ul>
            <li>
              Pytania pochodzą z publikowanych zestawów przykładowych pytań egzaminacyjnych
              Polskiego Związku Żeglarskiego oraz Polskiego Związku Motorowodnego i Narciarstwa
              Wodnego, a także z opracowań szkół żeglarskich. Materiał z kilku źródeł scalamy
              i deduplikujemy.
            </li>
            <li>
              Tam, gdzie źródła podawały sprzeczne odpowiedzi, rozstrzygamy je względem przepisu,
              a nie większością głosów.
            </li>
            <li>
              Wyjaśnienia i podstawy prawne piszemy sami - chodzi o zrozumienie przepisu,
              a nie zapamiętanie litery odpowiedzi.
            </li>
            <li>
              Treści przeglądamy przy zmianach przepisów. Jeżeli znajdziesz błąd merytoryczny,
              napisz - poprawiamy i dopisujemy źródło.
            </li>
          </ul>
          <p className={styles.note}>
            Zeglarka.pl jest serwisem edukacyjnym. Nie jest oficjalną stroną Polskiego Związku
            Żeglarskiego ani Polskiego Związku Motorowodnego i Narciarstwa Wodnego, nie wydaje
            patentów i nie przeprowadza egzaminów. Nie zastępuje też aktualnych aktów prawnych -
            w sprawach formalnych potwierdzaj wymagania u organizatora egzaminu.
          </p>
        </section>

        <section className={styles.section}>
          <h2>Kto prowadzi serwis</h2>
          <p>
            Właścicielem i administratorem serwisu jest <strong className="dane-adm-nazwa" />,{' '}
            <span className="dane-adm-adres" />. Kontakt:{' '}
            <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>.
          </p>
          <p>
            Pełne zasady korzystania z serwisu opisuje <Link to="/regulamin">regulamin</Link>,
            a zasady przetwarzania danych -{' '}
            <Link to="/polityka-prywatnosci">polityka prywatności</Link>.
          </p>
        </section>

        <div className={styles.ctaBox}>
          <h2>Zacznij od darmowego testu</h2>
          <p>Sprawdź formę nauki bez rejestracji i bez opłat.</p>
          <div className={styles.ctaRow}>
            <Link to="/egzamin/zeglarz-jachtowy" className={styles.primaryButton}>
              Rozwiąż darmowy test
            </Link>
            <Link to="/zeglarz-jachtowy" className={styles.secondaryButton}>
              Przewodnik po patencie
            </Link>
          </div>
        </div>
      </article>
    </main>
  </>
);

export default AboutUs;
